import React from 'react';

export const LoginLink = () => {
    return <a href="https://zaycev.net/profile/index.php">Войти в аккаунт</a>;
};
